import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3612898653/src/easymeat-web/src/app/HomeContent.tsx");
